import React from "react";
import { Button } from "Components/Base/Inputs/Button";
import { Grid } from "Components/Base/Layout/Grid";
import { Box } from "Components/Base/Layout/Box";
import SearchField from "Components/Fragment/SearchField";
import FormControlSelect from "Components/Fragment/Inputs/FormControlSelect";
import { FilterIcon } from "Components/Icons";
import {
  STYLE_FILTER_BUTTON,
  STYLE_GRID_CONTAINER,
  STYLE_SEARCH_FIELD,
  STYLE_SEARCH_FIELD_MOBILE,
  STYLE_CONTROLS_BOX,
  STYLE_SELECT,
} from "../styles";
import { useToolbar } from "../hooks";
import { getViewOptions } from "../utils/toolbarUtils";

export const FilterControls = ({
  languageContext,
  onFilter,
  isFilterOpen,
  buttonRef,
}) => {
  const handleFilterClick = () => {
    onFilter();
  };

  if (isFilterOpen) {
    return null;
  }

  return (
    <div ref={buttonRef}>
      <Button
        disableFocusRipple={true}
        variant="outlined"
        onClick={handleFilterClick}
        sx={STYLE_FILTER_BUTTON}
      >
        {<FilterIcon />}
        {languageContext("showCatalogueFilters")}
      </Button>
    </div>
  );
};

const Toolbar = ({ languageContext, isMobile = false, filterButtonRef }) => {
  const {
    searchText,
    listView,
    sortOptionValue,
    showAdvancedFilter,
    sortTypeOnChange,
    handleSearchChange,
    handleSearchClear,
    handleSearchSubmit,
    toggleListView,
    handleShowAdvancedFilter,
    sortOptions,
  } = useToolbar();

  if (isMobile) {
    return (
      <Box sx={STYLE_GRID_CONTAINER}>
        <SearchField
          value={searchText}
          ariaLabel={languageContext("searchCatalogue")}
          placeholder={languageContext("searchCatalogue")}
          searchLabel={languageContext("searchCatalogue")}
          clearLabel={languageContext("clearSearch")}
          onChange={handleSearchChange}
          onClear={handleSearchClear}
          onSubmit={handleSearchSubmit}
          searchMode="onSubmit"
          sx={STYLE_SEARCH_FIELD_MOBILE}
        />
      </Box>
    );
  }

  return (
    <Grid
      container
      spacing={2}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={STYLE_GRID_CONTAINER}
    >
      <Grid item xs={12}>
        <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          flexWrap="wrap"
          gap={2}
          alignItems={{ xs: "stretch", sm: "center" }}
          justifyContent={{ xs: "stretch", sm: "space-between" }}
        >
          <SearchField
            value={searchText}
            ariaLabel={languageContext("searchCatalogue")}
            placeholder={languageContext("searchCatalogue")}
            searchLabel={languageContext("searchCatalogue")}
            clearLabel={languageContext("clearSearch")}
            onChange={handleSearchChange}
            onClear={handleSearchClear}
            onSubmit={handleSearchSubmit}
            searchMode="onSubmit"
            sx={STYLE_SEARCH_FIELD}
          />

          <Box
            display="flex"
            alignItems="center"
            gap={1}
            flexWrap="wrap"
            sx={STYLE_CONTROLS_BOX}
          >
            <FormControlSelect
              className="filter-sort-select"
              name="sortCoursesBy"
              idBase="sort-courses-by"
              label={languageContext("sortcoursesby")}
              options={sortOptions}
              value={sortOptionValue}
              onChange={(sortValue) => sortTypeOnChange(sortValue)}
              languageContext={languageContext}
              displayLabel={false}
              sx={STYLE_SELECT}
              translateOptions={true}
            />
            <FormControlSelect
              className="filter-sort-select"
              name="view"
              idBase="view"
              label={languageContext("view")}
              options={getViewOptions(languageContext)}
              value={listView ? "list" : "card"}
              onChange={(view) => toggleListView(view)}
              sx={STYLE_SELECT}
              displayLabel={false}
              removeIdFromAriaLabelledby={true}
            />
            <FilterControls
              languageContext={languageContext}
              onFilter={handleShowAdvancedFilter}
              isFilterOpen={showAdvancedFilter}
              buttonRef={filterButtonRef}
            />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Toolbar;
